export default __webpack_public_path__ + "static/media/twitter.830acb42.svg";